<template>
  <div class="fvForm">
    <div class="row mb-5" v-if="!userIsGuest">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div>
          <br>
          <label class="typo__label">Lista punktów dostaw</label>
          <multiselect
            v-model="selected"
            :options="backendDeliveries"
            :custom-label="nameWithLang"
            @select="changeDelivery"
            placeholder="Wybierz z listy"
            label="name"
            track-by="name"
            selectLabel="Wciśnij enter, aby wybrać"
            deselectLabel="Wciśnij enter, aby odznaczyć"
            selectedLabel="Wybrany"
          ></multiselect>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
        <a @click="copyData" class="btn btn-primary copy-data">Kopiuj dane z danych do faktury</a>
      </div>
    </div>
    <h3>Dane dostawy</h3>
    <CustomAlert v-if="companyNameWasCropped" type="warning">
      <p class="mb-0">
        <b>Uwaga!</b>
        <br />
        Pole "Adresat" zostało automatycznie ograniczone do {{ maxCompanyNameLength }} znaków.
      </p>
    </CustomAlert>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <input type="hidden" v-model="token">
        <basic-input
          :validationRule="`required|max:${maxCompanyNameLength}`"
          name="companyName"
          label="Adresat"
          placeholder="Adresat/Nazwa Firmy"
          inputType="text"
          v-model="companyName"
          :disabled="readonly"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-6">
        <basic-input
          validationRule="required"
          name="dvStreet"
          label="Ulica"
          placeholder="Ulica"
          inputType="text"
          v-model="street"
          :disabled="readonly"
        />
      </div>

      <div class="col-md-3 col-lg-3">
        <basic-input
          validationRule="required"
          name="dvStreetNumber"
          label="Nr budynku"
          placeholder="Nr budynku"
          inputType="text"
          v-model="streetNumber"
          :disabled="readonly"
        />
      </div>
      <div class="col-md-3 col-lg-3">
        <basic-input
          name="dvLocalNumber"
          label="Nr lokalu"
          placeholder="Nr lokalu"
          inputType="text"
          v-model="localNumber"
          :disabled="readonly"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-6">
        <basic-input
          validationRule="required"
          name="dvCity"
          label="Miasto"
          placeholder="Miasto"
          inputType="text"
          v-model="city"
          :disabled="readonly"
        />
      </div>
      <div class="col-md-3 col-lg-3">
        <basic-masked-input
          validationRule="zipCode|required"
          name="dvZipCode"
          label="Kod pocztowy"
          placeholder="Kod pocztowy"
          inputType="text"
          :mask="'##-###'"
          v-model="zipCode"
          :disabled="readonly"
        />
      </div>
      <div class="col-md-3 col-lg-3">
        <basic-masked-input
          validationRule="phone"
          name="dvCompanyPhone"
          label="Tel. firmowy"
          placeholder="Tel. firmowy"
          inputType="text"
          :mask="'#########'"
          v-model="companyPhone"
        />
      </div>
    </div>
    <h3>Upoważnieni do odbioru przesyłki</h3>
    <p>Prosimy potwierdzić przynajmniej jedną osobę upoważnioną do kontaktu. Rekomendujemy podanie dwóch osób, które będą mogły odebrać przesyłkę.</p>
    <section ref="contactPerson">
      <div class="contact-person-header">
        <Icon icon="card-plus" />
        <h4>Osoba nr 1</h4>
      </div>
      <div class="row">
        <div class="col-md-6">
          <basic-input
            validationRule="required"
            name="deliveryPersonName"
            label="Imię"
            v-model="personOneName"
            placeholder="Imię"
            inputType="text"
          />
        </div>
        <div class="col-md-6">
          <basic-input
            validationRule="required"
            name="deliveryPersonSurname"
            label="Nazwisko"
            v-model="personOneSurname"
            placeholder="Nazwisko"
            inputType="text"
          />
        </div>
        <div class="col-md-6">
          <basic-masked-input
            validationRule="required|phone"
            name="deliveryPersonPhone"
            label="Telefon kom."
            v-model="personOnePhone"
            placeholder="Telefon kom."
            :mask="'#########'"
            inputType="text"
          />
        </div>
      </div>
      <div class="contact-person-header">
        <Icon icon="card-plus" />
        <h4>Osoba nr 2</h4>
      </div>
      <div class="row">
        <div class="col-md-6">
          <basic-input
            name="deliveryPersonName"
            label="Imię"
            v-model="personSecondName"
            placeholder="Imię"
            inputType="text"
          />
        </div>
        <div class="col-md-6">
          <basic-input
            name="deliveryPersonSurname"
            label="Nazwisko"
            v-model="personSecondSurname"
            placeholder="Nazwisko"
            inputType="text" />
        </div>
        <div class="col-md-6">
          <basic-masked-input
            name="deliveryPersonPhone"
            label="Telefon kom."
            :mask="'#########'"
            v-model="personSecondPhone"
            placeholder="Telefon kom."
            inputType="text"
            validationRule="phone"
            />
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import { uuid } from 'uuidv4';
import BasicInput from '../Inputs/basicInput.vue';
import BasicMaskedInput from '../Inputs/basicMaskedInput.vue';
import { mapDynamicFields } from '../../utils/mapFields';
import { deliveryObject } from '../../utils/deliveryObject';
import Icon from '../Icon.vue';
import CustomAlert from '@/components/CustomAlert.vue';

const MAX_COMPANY_NAME_LENGTH = 50;

export default {
  name: 'deliveryAddresForm',
  props: ['delivery_id'],
  components: {
    BasicMaskedInput,
    BasicInput,
    Multiselect,
    Icon,
    CustomAlert,
  },
  data() {
    return {
      selected: '',
      readonly: false,
      typeahead: '',
      isDataAreCopied: false,
      companyNameWasCropped: false,
    };
  },
  created() {
    this.$store.dispatch('delivery/setDeliveryToken', { index: this.indexArray, token: uuid() });
  },
  computed: {
    ...mapState('delivery', ['backendDeliveries']),
    ...mapState('cart', ['userIsGuest']),
    ...mapState('contactPerson', ['name', 'surname']),
    ...mapDynamicFields('delivery', [
      'address[].token',
      'address[].companyName',
      'address[].street',
      'address[].streetNumber',
      'address[].localNumber',
      'address[].city',
      'address[].zipCode',
      'address[].companyPhone',
      'address[].personOneName',
      'address[].personOneSurname',
      'address[].personOnePhone',
      'address[].personSecondName',
      'address[].personSecondSurname',
      'address[].personSecondPhone',
    ], 'indexArray', 'state'),
    indexArray() {
      return this.delivery_id;
    },
    state() {
      return this.$store.state;
    },
    maxCompanyNameLength() {
      return MAX_COMPANY_NAME_LENGTH;
    },
  },
  methods: {
    nameWithLang({ name, postcode, city }) {
      return `${name}, ${postcode}, ${city}`;
    },
    copyData() {
      this.companyNameWasCropped = false;
      const { fvForm, contactPerson, delivery } = this.$store.state;

      const newDelivery = { ...deliveryObject };

      newDelivery.token = delivery.address[this.$props.delivery_id].token;
      newDelivery.companyName = fvForm.companyName;
      newDelivery.street = fvForm.street;
      newDelivery.streetNumber = fvForm.streetNumber;
      newDelivery.localNumber = fvForm.localNumber;
      newDelivery.city = fvForm.city;
      newDelivery.zipCode = fvForm.zipCode;
      newDelivery.companyPhone = fvForm.companyPhone;
      newDelivery.personOneName = contactPerson.name;
      newDelivery.personOneSurname = contactPerson.surname;
      newDelivery.personOnePhone = fvForm.companyPhone;
      newDelivery.delivery_file = delivery.address[this.$props.delivery_id].delivery_file;

      this.$store.dispatch('delivery/setAddress', [newDelivery, this.$props.delivery_id]);
      this.selected = '';
      this.readonly = false;
      this.isDataAreCopied = true;
    },
    clear() {
      const { delivery } = this.$store.state;
      deliveryObject.token = delivery.address[this.$props.delivery_id].token;
      this.$store.dispatch('delivery/setAddress', [deliveryObject, this.delivery_id]).then(() => {
        this.readonly = false;
        this.selected = '';
        this.isDataAreCopied = false;
      });
    },
    changeDelivery(selected) {
      this.companyNameWasCropped = false;
      const deliveryAddress = selected;
      const { delivery } = this.$store.state;

      let companyName = deliveryAddress.name;

      if (companyName && companyName.length > this.maxCompanyNameLength) {
        companyName = companyName.slice(0, this.maxCompanyNameLength);
        this.companyNameWasCropped = true;
      }

      const newDelivery = {
        token: delivery.address[this.$props.delivery_id].token,
        companyName,
        external_id: deliveryAddress.external_id,
        internal_id: deliveryAddress.iddelivery,
        street: deliveryAddress.street,
        streetNumber: deliveryAddress.street_number,
        localNumber: deliveryAddress.flat_number,
        city: deliveryAddress.city,
        zipCode: deliveryAddress.postcode,
        companyPhone: deliveryAddress.phone,
        personOneName: deliveryAddress.contact_person_first_name,
        personOneSurname: deliveryAddress.contact_person_first_surname,
        personOnePhone: deliveryAddress.contact_person_first_phone,
        personSecondName: deliveryAddress.contact_person_second_name,
        personSecondSurname: deliveryAddress.contact_person_second_surname,
        personSecondPhone: deliveryAddress.contact_person_second_phone,
        delivery_file: delivery.address[this.$props.delivery_id].delivery_file,
      };
      this.$store.dispatch('delivery/setAddress', [newDelivery, this.delivery_id]).then(() => {
        this.readonly = true;
        this.isDataAreCopied = false;
      });
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
